import React from 'react';

import PageHeader from '../../../../components/common/PageHeader';
import { LB_HEADER } from '../../../../utils/constant/labels';

const { LB_COMPLAIN } = LB_HEADER;

const ComplainTools = () => {
  return <PageHeader headerTitle={LB_COMPLAIN} />;
};

export default ComplainTools;
